import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import fonts from '../../design-system/fonts';
import colors from '../../design-system/colors';

export const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${colors.porcelain};
`;

export const Container = styled(motion.div)`
  flex: 1;
  padding: 120px 40px 80px;
  margin: 0 auto;
  width: 100%;
  max-width: 1400px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media (max-width: 1024px) {
    padding: 100px 30px 60px;
  }

  @media (max-width: 768px) {
    padding: 100px 20px 60px;
  }

  @media (max-width: 480px) {
    padding: 90px 16px 40px;
  }
`;

export const Title = styled(motion.h1)`
  font-size: 72px;
  font-weight: 900;
  color: ${colors.sapphire};
  margin: 0;
  font-family: ${fonts.headline};
  letter-spacing: -0.03em;
  line-height: 1.1;
  position: relative;
  display: inline-block;

  &::after {
    content: '';
    position: absolute;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 4px;
    background: ${colors.goldenBronze};
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    font-size: 48px;
  }

  @media (max-width: 480px) {
    font-size: 36px;
  }
`;

export const Message = styled(motion.p)`
  font-size: 20px;
  line-height: 1.6;
  color: ${colors.deepCharcoal};
  margin: 40px 0 0 0;
  font-family: ${fonts.body};
  max-width: 520px;

  @media (max-width: 768px) {
    font-size: 18px;
    margin: 30px 0 0 0;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    margin: 24px 0 0 0;
  }
`;

export const BackLink = styled(Link)`
  display: inline-block;
  margin-top: 48px;
  padding: 16px 32px;
  background: ${colors.deepCharcoal};
  color: ${colors.porcelain};
  border: none;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-decoration: none;
  font-family: ${fonts.body};
  transition: all 0.3s ease;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;

  &:hover {
    background: ${colors.sapphire};
  }

  @media (max-width: 480px) {
    margin-top: 36px;
    padding: 14px 24px;
    font-size: 12px;
  }
`;
